du<template>
  <section>
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="true"></loading>
    </div>
    <div class="header">
      <span>
        <div class="header-box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <div class="title-text"> Hello, {{ profile.displayName | '' }} </div>
                <div class="title-bold"> Your Libra Wallet </div>
              </div>
            </div>
            <div class="media-right">
              <figure class="image is-64x64">
                <img v-if=profile.pictureUrl class="is-rounded" :src=profile.pictureUrl alt="Image">
                <img v-else class="is-rounded" src="https://test.iyawat.com/libra-chatbot/nodejs/images/libra-bg.jpg" alt="img" style="width: 50px;    margin: 0 auto;">
              </figure>
            </div>
          </article>
        </div>
      </span>
    </div>
    <div class="wallet">
      <span>
        <div class="columns">
          <div class="column is-one-fifth"> </div>
          <div class="column is-three-fifths">
            <div class="row">
              <img src="libra-logo.png" alt="img" style="width: 80%; max-width: 500px; margin: 0 auto;">
            </div>
            <div class="row">
              <b-message
                :closable="false"
                title="Wallet Address: "
                type="is-info"
                has-icon style="overflow-wrap: break-word;"
              >
                <p v-if="!fetched"> Loading .. </p>
                <p v-if="fetched"> {{ wallet.accountno }} </p>
              </b-message>
              <b-message
                :closable="false"
                title="Balance: "
                type="is-info"
                has-icon style="overflow-wrap: break-word;"
              >
                <p v-if="!fetched"> Loading .. </p>
                <p class="balance" v-if="fetched"> {{ wallet.balance | numberWithCommas }} </p>
              </b-message>
            </div>
            <br>
            <div class="button-box">
              <router-link  to="/Transfer">
              <b-button
                icon-left="money-check-alt"
              >
                Send
              </b-button>
              </router-link>
              <br>
              <router-link  to="/Receive">
                <b-button
                  icon-left="qrcode"
                >
                  Receive
                </b-button>
              </router-link>
              <br>
              <router-link to="/Transaction">
              <b-button
                icon-left="history"
              >
                Transaction History
              </b-button>
              </router-link>

            </div>
          </div>
          <div class="column is-one-fifth"> </div>
        </div>
      </span>
    </div>
    <FooterBar />
  </section>
</template>

<script>
// require styles
import FooterBar from '@/views/Footer'
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import UserDataPersistance from '@/userData/persistance'
import { mapState, mapActions } from 'vuex'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  name: 'Home',
  components: {
    FooterBar,
    Loading
  },
  data: () => ({
    isLoading: true,
    userData: null,
    fetched: false,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    }
  }),
  filters: {
    numberWithCommas (x) {
      if (x !== undefined) {
        let parts = x.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.getProfile()
    }, 1000)
    // Load from local storage
    this.userData = new UserDataPersistance()
  },
  computed: {
    ...mapState({
      wallet: state => state.wallet
    })
  },
  methods: {
    ...mapActions({
      createWallet: 'createWallet'
    }),
    sendMessage () {
      this.$liff.sendMessages([this.wallet.message[0]])
        .then(function () {
          // alert('Account = ', response.data.accountno)
          Toast.open({
            message: 'Message sent to your line',
            type: 'is-success'
          })
        }).catch(function (error) {
          Toast.open({
            message: 'Error sending message: ' + error,
            type: 'is-danger'
          })
        })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
        _this.createWallet({
          'userId': profile.userId,
          'displayName': profile.displayName,
          'profileURL': profile.pictureUrl
        }).then(wallet => {
          _this.isLoading = false
          setTimeout(() => {
            _this.fetched = true
          }, 3000)
          _this.updatePersistance(wallet.accountno, wallet.balance, wallet.mnemonic)
        })
      }).catch(function (error) {
        Toast.open({
          message: 'Error getting profile: ' + error,
          type: 'is-danger'
        })
      })
    },
    async updatePersistance (userAddress, balance, mnemonic) {
      this.userData.update(userAddress, balance, mnemonic)
      this.userData.save()
    }
  }
}
</script>

<style lang="css">
@import 'https://fonts.googleapis.com/css?family=Kanit|Prompt';

  main, html, body {
    font-family: 'Prompt', sans-serif;
    overflow-x: none;
    -webkit-overflow-scrolling: touch;
    background-color: #F4F4F4;
  }
  .header {
    overflow:hidden;
  }
  .header-box {
    background-color: rgb(76, 0, 114);
    border-radius: 0;
    padding: 5% 5% 5% 5%;
  }
  .title-bar {
    background-color: rgb(76, 0, 114);
  }
  .title-text {
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    letter-spacing: .5px;
  }
  .title-bold{
    font-weight: 400;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.801);
    letter-spacing: .5px;
  }

  .balance {
    font-size: 30px;
    font-weight: bold;
    vertical-align: middle;
  }
</style>

<style lang="scss" scoped>
.button-box {
  margin-top: 25px;
  padding: 0 30px;
  button {
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
    max-width: 300px;
  }
}
</style>
